import { ViewController, JsonFeed, ModelUpdateEvent, DataReceiveEvent, MaintenanceEvent, CustomerIntegrationController,
         VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, BetPlaceEvent, TimeoutEvent, GuiResizeEvent,
         RelayoutEvent, GuiSwitchEvent, WIDGET_LIVETABLE } from "@gaming/srvg-classes-core";
import { WebView } from "../../View/AppView/WebView";
import { GuiSwitchController } from "../GuiSwitchController";
import { LiveSettlementsViewController } from "./LiveSettlementsViewController";
import { TimelineController } from "../TimelineController";
import { OddsfeedController } from "../OddsfeedController";
import { MatchIdsFeedController } from "../MatchIdsFeedController";
import { LiveTableController } from "../LiveTableController";
import { OverlayViewController } from "./OverlayViewController";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class WebViewController extends ViewController {
    webView: WebView;

    guiSwitchController: GuiSwitchController;
    liveTableController: LiveTableController;
    overlayViewController: OverlayViewController;
    titlebarController: TitlebarController;
    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;
    liveSettlementsViewController: LiveSettlementsViewController;

    constructor( options ) {
        options = options || {};
        options.view = options.webView || null;
        super( options );
        this.name = 'vblWebViewController';

        this.webView = options.webView || null;

        /******************* initialize controllers ************************/

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.webView.videoView,
            videoControlBar: this.webView.videoControlBar,
            channel: srvg.videooptions.defaultchannel
        } ) );

        app.timelineController       = new TimelineController( { url: srvg.url.timeline } );
        app.oddsfeedController       = new OddsfeedController({
            feed: new JsonFeed( { url: srvg.url.oddsfeed } ),
            maxSize: 60
        });
        app.matchIdsFeedController = new MatchIdsFeedController( {
            feed: new JsonFeed( { url: srvg.url.matchidsfeed } ),
            maxSize: 60
        } );
        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.webView.titlebar } ) );
        app.customerIntegration       = new CustomerIntegrationController( {} );
        srvg.customerIntegration = app.customerIntegration;
        this.guiSwitchController      = this.addChildViewController( new GuiSwitchController({
            button: this.webView.guiSwitch,
            wrapper: '#wrapper',
            compactClass: 'compact_view',
            skillClass: 'skill_view'
        }));
        this.liveTableController      = this.addChildViewController( new LiveTableController( {
            button: '#livetable_button',
            liveTable: this.webView.liveTable,
            liveTableWidget: srvg.widgets[WIDGET_LIVETABLE].enabled ? this.webView.widgetLivetable : null
        }) );
        this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
            overlayView: this.webView.overlayContainerView,
            teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
            teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
        } ) );

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.webView.matchdayArea
        }) );

        /******************* connect components ************************/

        if( this.webView.matchdayArea.matchdayPicker ) {
            // FIXME move
            this.webView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.customerIntegration, ModelUpdateEvent );
            app.inactivityController.addSubscriberForEvent( this.matchdayAreaController.matchdaypickerController, TimeoutEvent );
        }
        this.webView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.oddsfeedController, ModelUpdateEvent );
        this.webView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
        app.matchIdsFeedController.addSubscriberForEvent( app.customerIntegration, DataReceiveEvent );

        app.oddsfeedController.addSubscriberForEvent( this.matchdayAreaController, DataReceiveEvent );
        app.timelineController.addSubscriberForEvent( srvg.maintenance, MaintenanceEvent );

        app.timelineController.addSubscriberForEvent( app.customerIntegration,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.titlebarController,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( app.server,                 TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent( this.overlayViewController, PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,       VideoReloadEvent );

        app.inactivityController.addSubscriberForEvent( this.titlebarController, TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.timelineController,  TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( this.videoController,    TimeoutEvent );
        app.inactivityController.addSubscriberForEvent( app.customerIntegration, TimeoutEvent );

        if(this.webView.matchdayArea.oddsGallery) {
            this.webView.matchdayArea.oddsGallery.addSubscriberForEvent( app.customerIntegration, BetPlaceEvent );
        }
        this.guiSwitchController.addSubscriberForEvent( app.customerIntegration, GuiResizeEvent );

        var exch = srvg.eventExchange;


        if( srvg.widgets[WIDGET_LIVETABLE].enabled ) {
            this.guiSwitchController.addSubscriberForEvent(this.liveTableController, GuiSwitchEvent);
            this.webView.liveTable.addSubscriberForEvent(this.liveTableController, RelayoutEvent);
        }
        if( srvg.widgets['livesettlements'].enabled){
            this.liveSettlementsViewController = this.addChildViewController(
                new LiveSettlementsViewController({livesettlementWidget: this.webView.widgetLivesettlements})
            );
            this.guiSwitchController.addSubscriberForEvent(this.liveSettlementsViewController, GuiSwitchEvent);
        }

        exch.addEventHandler(this.videoController,             'all',                          ChannelSwitchEvent );
        exch.addEventHandler(this.overlayViewController,       'all',                          ChannelSwitchEvent );
        exch.addEventHandler(app.customerIntegration,          'all',                          ChannelSwitchEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        app.inactivityController.startWaiting();
        this.videoController.play();
        app.customerIntegration.startCustomerActions();
    }
}